<template>
    <AxRoadPage :is-loading="isLoading" :title="$t('router.tachograph')">
        <div class="l-stack l-gap-3">
            <CalendarFilter
                v-model="selectedDate"
                class="tachograph__calendar-filter"
                :marked-days="warningDates"
                @input="handleDayClick"
            />
            <WarningAlert
                v-for="warning in warnings"
                :key="warning.id"
                :warning="warning"
            />
            <TruckTimelineMeasurementFragment
                v-if="lastAsset || driver"
                class="tachograph__measurements"
                :selected-date="selectedDate"
                :driver="driver"
                :tracker="lastAsset"
                :has-title="false"
            />
            <template v-if="selectedDate === today">
                <AxRoadDriverTachograph
                    v-if="lastAsset && isSameDriver"
                    class="tachograph__sensor-data"
                    :sensor-data="lastAsset.asset_details.sensor_data"
                    :show-all-drivers="false"
                />
                <div v-else class="l-stack l-gap-3 l-padded-y">
                    <p class="l-center">
                        {{ $t('no_truck') }}
                    </p>
                </div>
            </template>
        </div>
    </AxRoadPage>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

import AxRoadDriverTachograph from '@/components/ax-road/AxRoadDriverTachograph'
import AxRoadPage from '@/components/ax-road/AxRoadPage'
import CalendarFilter from '@/components/redesigned/CalendarFilter'
import TruckTimelineMeasurementFragment from '@/components/TruckTimelineMeasurementFragment'
import WarningAlert from '@/components/ax-road/WarningAlert'

export default {
    name: 'DriverTachographView',
    components: {
        AxRoadDriverTachograph,
        AxRoadPage,
        CalendarFilter,
        TruckTimelineMeasurementFragment,
        WarningAlert,
    },
    data() {
        return {
            asset: null,
            isLoading: false,
            selectedDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
        }
    },
    computed: {
        ...mapGetters('tracker', ['driversById', 'assetsByAssetId']),
        ...mapGetters('warnings', ['driverWarningsMap']),
        driver() {
            return this.driversById[this.$route.params.id] || null
        },
        lastAsset() {
            return this.assetsByAssetId[this.driver?.last_asset?.id] || null
        },
        isSameDriver() {
            return (
                this.lastAsset?.asset_details?.sensor_data?.driver_id?.value ===
                this.driver?.driver_id
            )
        },
        warnings() {
            return (this.driverWarningsMap[this.driver?.id] || []).filter(
                warning => !warning.resolved
            )
        },
        warningDates() {
            return this.warnings.map(warning =>
                moment(warning.timestamp).format('YYYY-MM-DD')
            )
        },
    },
    watch: {
        '$route.params.id': 'fetchTruck',
        '$route.query.date'(newDate) {
            if (newDate) {
                this.selectedDate = newDate
            }
        },
    },
    created() {
        this.selectedDate = this.$route.query.date || this.selectedDate
    },
    methods: {
        handleDayClick(day) {
            this.$router.replace({
                name: 'axRoadDriverTachograph',
                params: { id: this.$route.params.id },
                query: { ...this.$route.query, date: day },
            })
        },
    },
}
</script>
<i18n>
{
    "en": {
        "no_truck": "No tachograph data available"
    },
    "de": {
        "no_truck": "Keine Tachografdaten verfügbar"
    },
    "fr": {
        "no_truck": "Aucune donnée de tachygraphe disponible"
    },
    "it": {
        "no_truck": "Nessun dato del tachigrafo disponibile"
    }
}
</i18n>

<style lang="scss" scoped>
.tachograph {
    &__calendar-filter {
        top: 0;
        position: sticky;
    }
    &__measurements {
        min-height: 15vh;
    }
    &__sensor-data {
        max-width: 950px;
        margin: auto;
    }
}
</style>
